import { HelpOverlayShell } from './components/HelpOverlayShell';
import { ChatPane } from './panes/ChatPane';
import { FaqPane } from './panes/FaqPane';
import { useHelp } from './useHelp';

/** Composes the shell with the two panes from provider state. Mounted once, via portal. */
export function HelpOverlay() {
  const { isOpen, activeContext, parentContext, closeHelp, setContext } = useHelp();

  return (
    <HelpOverlayShell
      open={isOpen}
      contextLabel={activeContext.label}
      parentLabel={parentContext?.label ?? null}
      onParentClick={parentContext ? () => setContext(parentContext.key) : undefined}
      onClose={closeHelp}
      faqPane={<FaqPane key={activeContext.key} />}
      chatPane={<ChatPane />}
    />
  );
}
